import { useState, useEffect } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  Button, Grid, FormControlLabel, Switch, Snackbar, Alert
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getSitesOrdersPrintConfig, updateLocationPrinterSettings } from '../../../services/SettingsService';

const PrinterSettingsModal = ({ open, onClose, location }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    view_print: false,
    auto_print: false,
    comanda_print: false,
    loyalty_card_print: false,
    loyalty_card_print_available: false,
  });
  const [saving, setSaving] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (location) {
        try {
          const printConfig = await getSitesOrdersPrintConfig(location.id);

          setFormData({
            view_print: printConfig.viewPrint,
            auto_print: printConfig.autoPrint,
            comanda_print: printConfig.comandaPrint,
            loyalty_card_print: printConfig.loyaltyCardPrint,
            loyalty_card_print_available: printConfig.loyaltyCardPrintAvailable,
          });
        } catch (err) {
          console.error('Error loading printer settings:', err);
        }
      }
    };

    if (open) fetchData();
  }, [open, location]);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const settings = [
          { key: `viewprint_location_${location.id}`, value: formData.view_print.toString() },
          { key: `autoprint_location_${location.id}`, value: formData.auto_print.toString() },
          { key: `comandaprint_location_${location.id}`, value: formData.comanda_print.toString() },
      ];
      if (formData.loyalty_card_print_available) {
        settings.push({ key: `loyaltycardprint_location_${location.id}`, value: formData.loyalty_card_print.toString() });
      }
      const payload = {
        settings
      };

      const success = await updateLocationPrinterSettings(location.id, payload);
      setSaving(false);

      if (success) {
        setSuccessOpen(true);
        onClose();
      }
    } catch (err) {
      console.error('Error saving printer settings:', err);
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('printer_settings')} ({location?.name})
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Switch checked={formData.view_print} onChange={handleChange} name="view_print" />}
              label={t('view_print')}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Switch checked={formData.auto_print} onChange={handleChange} name="auto_print" />}
              label={t('auto_print')}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Switch checked={formData.comanda_print} onChange={handleChange} name="comanda_print" />}
              label={t('comanda_print')}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={saving}>
          {saving ? t('saving') : t('save')}
        </Button>
      </DialogActions>

      <Snackbar
        open={successOpen}
        autoHideDuration={4000}
        onClose={() => setSuccessOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert severity="success">{t('settings_saved')}</Alert>
      </Snackbar>
    </Dialog>
  );
};

export default PrinterSettingsModal;
